import { render } from "./FaqEditor.vue?vue&type=template&id=74c69824&scoped=true"
import script from "./FaqEditor.vue?vue&type=script&lang=js"
export * from "./FaqEditor.vue?vue&type=script&lang=js"

import "./FaqEditor.vue?vue&type=style&index=0&id=74c69824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c69824"]])

export default __exports__